import { useState } from "react";
import { api, API } from "@/App";
import { Download, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const KEY = "kk_dl_email";
const NAMES = { denoise: "Denoise", skin: "Skin", texture: "Texture", reactor: "Reactor", genalpha: "Gen Alpha", recast: "Recast", rolloff: "Film Compression" };
const field = "flex-1 min-w-0 bg-[#0e1013] border border-[#2a2f3d] px-3 py-2.5 text-sm text-white focus:border-white outline-none transition-colors";

export const savedEmail = () => localStorage.getItem(KEY) || localStorage.getItem("kk_fc_unlocked");
export const saveEmail = (e) => localStorage.setItem(KEY, e);
export const productOf = (prefix) => (prefix ? prefix.slice(0, -1) : "genalpha");

const start = (target) => { window.location.href = `${API}/binary/${target}`; };

export function useTrialGate(prefix) {
  const [pending, setPending] = useState(null);
  const product = productOf(prefix);
  const download = (target) => {
    const email = savedEmail();
    if (!email) return setPending(target);
    api.post("/free/unlock", { email, product }).catch(() => {});
    start(target);
  };
  const dialog = <TrialDialog product={product} target={pending} onClose={() => setPending(null)} />;
  return { download, dialog };
}

function TrialDialog({ product, target, onClose }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr(null);
    try {
      await api.post("/free/unlock", { email: email.trim(), product });
      saveEmail(email.trim()); start(target); onClose();
    } catch (x) {
      setErr(x?.response?.status === 422 ? "Please enter a valid email address." : x?.response?.data?.detail || "Something went wrong, please try again.");
    }
    setBusy(false);
  };
  return (
    <Dialog open={!!target} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#0e1013] border-[#2a2f3d] text-white rounded-none" data-testid="trial-gate-dialog">
        <DialogHeader>
          <DialogTitle className="font-display uppercase text-xl">Download the {NAMES[product]} trial</DialogTitle>
          <DialogDescription className="text-[#9ba3b4]">Enter your email and the download starts right away. We also email you the links for your other machines.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div className="flex flex-col sm:flex-row gap-2">
            <input autoFocus className={field} type="email" required maxLength={200} placeholder="you@studio.com" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="trial-gate-email-input" />
            <button disabled={busy} className="btn-amber px-5 py-2.5 text-sm flex items-center justify-center gap-2 disabled:opacity-60" data-testid="trial-gate-submit-btn">
              {busy ? <Loader2 size={14} className="spin" /> : <Download size={14} />} Download
            </button>
          </div>
          {err && <div className="text-xs text-[#ff453a]" data-testid="trial-gate-error">{err}</div>}
        </form>
      </DialogContent>
    </Dialog>
  );
}
